import { TypeImage, TypeImageCollection } from "@contentful/types";
import { ImageCollectionCarousel } from "./ImageCollectionCarousel";

import type { JSX } from "react";
import { ImageCollectionGrid } from "./ImageCollectionGrid";
import { ImageCollectionSlideshow } from "./ImageCollectionSlideshow";
import { ImageCollectionTabs } from "./ImageCollectionTabs";

function ImageCollection({
  imageCollection,
  variant,
  wrapperClassName,
  headingWrapperClassName,
  headingClassName,
  slideClassName,
}: {
  imageCollection: TypeImageCollection<"WITHOUT_UNRESOLVABLE_LINKS">;
  variant?: "preview" | "detail" | "preview-small" | "modal" | undefined;
  wrapperClassName?: string;
  headingWrapperClassName?: string;
  headingClassName?: string;
  /** Applied to each mobile PeekSlider slide's image (`fit="natural"` keeps
   * the source photo's own aspect ratio uncapped, which can blow out on
   * mobile for a tall/square photo). Desktop Carousel images are unaffected. */
  slideClassName?: string;
}): JSX.Element {
  const images = imageCollection.fields.images.filter(
    (img): img is TypeImage<"WITHOUT_UNRESOLVABLE_LINKS"> =>
      img !== undefined && img.sys.contentType.sys.id === "image",
  );

  return imageCollection.fields.variant === "grid" ? (
    <ImageCollectionGrid images={images} />
  ) : imageCollection.fields.variant === "tabs" ? (
    <ImageCollectionTabs imageCollection={imageCollection} images={images} />
  ) : imageCollection.fields.variant === "slideshow" ? (
    <ImageCollectionSlideshow imageCollection={imageCollection} />
  ) : (
    // Package Detail With Carousel / variant = "image-above-thumbnails" || "slideshow-with-small-collection-image-top-left"
    <ImageCollectionCarousel
      imageCollection={imageCollection}
      variant={variant}
      wrapperClassName={wrapperClassName}
      headingWrapperClassName={headingWrapperClassName}
      headingClassName={headingClassName}
      slideClassName={slideClassName}
    />
  );
}

export { ImageCollection };
